import { useState } from "react";
import { Link } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useAuth } from "@/context/AuthContext";

const Seal = ({ className, title }) => (
  <BadgeCheck className={`inline-block shrink-0 align-middle gold-check fill-[#ec4899] text-white ${className}`} strokeWidth={2.25} role="img" aria-label={title} />
);

export const GoldCheck = ({ className = "w-4 h-4", testId, title = "Verifizierter Projekt Unterstützer" }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const vip = Boolean(user?.supporter);
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <span role="button" tabIndex={0} data-testid={testId} title={title} onClick={(e) => { stop(e); setOpen((o) => !o); }} onKeyDown={(e) => e.key === "Enter" && (stop(e), setOpen((o) => !o))}
          className="inline-flex shrink-0 align-middle cursor-pointer rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-pink-400 hover:scale-110 transition-transform">
          <Seal className={className} title={title} />
        </span>
      </PopoverTrigger>
      <PopoverContent collisionPadding={12} onClick={(e) => e.stopPropagation()} className="w-72 rounded-2xl p-0 overflow-hidden border-[#fda4af]/60" data-testid="gold-check-popover">
        <div className="vip-lux relative p-4">
          <span className="vip-lux-pattern" aria-hidden />
          <div className="relative flex items-center gap-3">
            <span className="w-11 h-11 rounded-full bg-white/95 flex items-center justify-center shadow-md"><Seal className="w-8 h-8" title={title} /></span>
            <div><p className="font-extrabold vip-gold-title leading-tight">Verifizierter Projekt Unterstützer</p><p className="text-[11px] text-[#fecdd3] mt-0.5">Premium-Account der itzPlay Community</p></div>
          </div>
          <p className="relative text-xs text-[#ffe4e6] mt-3 leading-relaxed">Dieser pinke Haken zeigt: Dieses Mitglied unterstützt Saskia & Stefan finanziell und hilft, die Kosten der Plattform zu tragen. Danke! 💖</p>
          <div className="relative mt-3">
            {vip
              ? <p className="text-xs font-bold text-white" data-testid="gold-check-you-are-vip">Du bist Projekt Unterstützer 💖 Danke für deine Unterstützung!</p>
              : <Link to="/community-unterstuetzen" onClick={() => setOpen(false)} data-testid="gold-check-become-vip" className="inline-flex h-9 px-4 items-center rounded-full vip-gold-metal text-xs font-extrabold">Auch Projekt Unterstützer werden 💖</Link>}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
